// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_valiant: PokeData = {
  "id": 1006,
  "name": "iron-valiant",
  "height": 14,
  "weight": 350,
  "base_experience": 295,
  "types": [
    PokeType.FAIRY,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "disable",
    "hypnosis",
    "double-team",
    "destiny-bond",
    "fury-cutter",
    "future-sight",
    "knock-off",
    "leaf-blade",
    "feint",
    "close-combat",
    "night-slash",
    "shadow-sneak",
    "psycho-cut",
    "wide-guard",
    "quick-guard",
    "moonblast",
    "dazzling-gleam",
    "spirit-break"
  ],
  "moves": [
    "future-sight",
    "close-combat",
    "night-slash",
    "shadow-sneak",
    "moonblast",
    "dazzling-gleam",
    "spirit-break",
    "moonlight",
    "play-rough",
    "misty-terrain",
    "coaching",
    "meteor-assault",
    "starfall"
  ],
  "evolution_chain": {
    "id": 534,
    "item": null,
    "species": [
      {
        "name": "iron-valiant",
        "order": 993,
        "types": [
          PokeType.FAIRY,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 93,
    "speed": 145,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
